module.exports = __webpack_public_path__ + "img/started_white.6caea23c.svg";